export default __webpack_public_path__ + "static/media/Lottie 9781408324967.7c33a496.jpg";